import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import i18next from 'i18next';
import bg from './i18n/bg';
import en from './i18n/en';
import authRoles from 'src/app/auth/authRoles';

i18next.addResourceBundle('bg', 'settingsPage', bg);
i18next.addResourceBundle('en', 'settingsPage', en);



const SettingsApp = lazy(() => import('./SettingsApp'));
const AccountTab = lazy(() => import('./tabs/AccountTab'));
const SecurityTab = lazy(() => import('./tabs/SecurityTab'));
const PlanBillingTab = lazy(() => import('./tabs/PlanBillingTab'));
const NotificationsTab = lazy(() => import('./tabs/NotificationsTab'));
const TeamTab = lazy(() => import('./tabs/TeamTab'));
const HotelTab = lazy(() => import('./tabs/HotelTab'));




/**
 * The Settings app config.
 */
const SettingsAppConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: 'settings',
			element: <SettingsApp />,
			children: [
				{
					path: 'hotel',
					element: <HotelTab/>
				},
				{
					path: 'account',
					element: <AccountTab />
					
				},
				{
					path: 'security',
					element: <SecurityTab />
				},
				{
					path: 'plan-billing',
					element: <PlanBillingTab />,
					auth: authRoles.admin
				},
				{
					path: 'security',
					element: <SecurityTab />
				},
				{
					path: 'notifications',
					element: <NotificationsTab />
				},
				{
					path: 'team',
					element: <TeamTab />,
					auth: authRoles.admin
				},
				{
					path: '',
					element: <Navigate to="account" />
				}
			]
		}
	]
};

export default SettingsAppConfig;
